const USE_LOCALHOST =
  import.meta.env.DEV && import.meta.env.VITE_USE_LOCALHOST_API === "1";

const productionApiUrl = () => {
  if (import.meta.env) {
    const fallbackURL = import.meta.env.VITE_FALLBACK_API_URL;

    // Throw error if fallbackURL is not set in development,
    // This could save developers from confusion when the env variable is missing
    if (!fallbackURL) {
      throw new Error(
        "VITE_FALLBACK_API_URL environment variable is required in development",
      );
    }

    return fallbackURL;
  }

  const host = window.location.host;
  const apiHost = host.replace(/^[^.]+/, "api");
  return `https://${apiHost}`;
};

const localhost = import.meta.env.DEV && USE_LOCALHOST;
export const API_URL = localhost ? "http://localhost:3101" : productionApiUrl();
export const WS_URL = localhost ? "http://localhost:3100" : API_URL;
